<template>
  <v-row class="h-full justify-center algin-center d-flex py-4 ma-0">
    <v-col
      cols="12"
      sm="6"
      lg="4"
      style="maxwidth: 600px"
      class="d-flex flex-column align-center justify-center ma-0"
    >
      <v-card class="w-full">
        <v-card-title class="d-flex justify-center">
          <r-img
            alt="Company Logo"
            class="my-2"
            :src="logo"
            max-width="140"
            cover
          />
        </v-card-title>

        <v-card-text v-if="isLoading">
          <div class="d-flex flex-column align-center">
            <v-progress-circular
              indeterminate
              color="primary"
              width="3"
              size="30"
            />
            <p>{{ $t('crm.on-office-service-app.loading-text') }}</p>
          </div>
        </v-card-text>

        <v-card-text v-if="isConnected">
          <div class="d-flex flex-column align-center">
            <p>{{ $t('crm.on-office-service-app.connected-text') }}</p>
          </div>
        </v-card-text>

        <v-card-text v-if="errorMessage">
          <v-alert
            class="ma-0"
            type="error"
          >
            <span>
              {{ errorMessage }}
            </span>
          </v-alert>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import logo from '@/assets/img/logo.png'
import bus, { eventNames } from '@/lib/eventBus'
import brandingMixin from '@/mixins/branding'

export default {
  mixins: [brandingMixin],
  data() {
    return {
      error: null,
      submitState: 'PENDING',
      logo,
    }
  },
  computed: {
    isConnected() {
      return this.$auth.isAuthenticated
    },
    isLoading() {
      return this.$auth.loading
    },
    errorMessage() {
      const url = new URL(window.location.href)
      const {
        apiClaim: extendedClaim,
        timestamp,
        customerName,
        customerWebId,
        userId,
        signature,
        parameterCacheId,
      } = Object.fromEntries(url.searchParams.entries())
      if (
        ![
          extendedClaim,
          timestamp,
          customerName,
          customerWebId,
          userId,
          signature,
          parameterCacheId,
        ].every(Boolean)
      ) {
        return this.$t('crm.on-office-service-app.error-messages.invalid-call')
      }
      return {
        'user-not-found': this.$t('crm.on-office-service-app.error-messages.user-not-found'),
        'marketplace-app-not-allowed': this.$t(
          'crm.on-office-service-app.error-messages.marketplace-app-not-allowed'
        ),
        unknown: this.$t('crm.on-office-service-app.error-messages.unknown'),
        'invalid-parameter': this.$t('crm.on-office-service-app.error-messages.invalid-call'),
      }[this.$auth.error]
    },
  },
  created() {
    if (this.$auth.isAuthenticated) {
      this.$router.push('/dashboard')
    } else {
      bus.$on(eventNames.USER_LOGGED_IN, () => {
        this.$router.push('/dashboard')
      })
    }
  },
}
</script>
